// TODO: Before finalizing merge both error components into one.
function ErrorText(props) {
  const error = props.error;
  return <p className="error_text">{error}</p>;
}

export default ErrorText;
